import { autoAttributesPlugin } from "@growthbook/growthbook/plugins";
import { GrowthBook, GrowthBookProvider } from "@growthbook/growthbook-react";
import { PropsWithChildren, useEffect } from "react";

const featureFlagClient = new GrowthBook({
  apiHost: "https://cdn.growthbook.io",
  clientKey: process.env.REACT_APP_GROWTH_BOOK_CLIENT_KEY,
  enableDevMode: process.env.REACT_APP_ENVIRONMENT === "DEVELOPMENT",
  plugins: [autoAttributesPlugin()],
  trackingCallback: (experiment: any, result: any) => {
    console.log("Experiment Viewed", {
      experimentId: experiment.key,
      variationId: result.key,
    });
  },
});

export function FeatureFlagProvider(props: PropsWithChildren) {
  useEffect(() => {
    async function init() {
      try {
        const response = await featureFlagClient.init();
        if (!response.success) throw response.error;
      } catch (error) {
        console.error("FeatureFlagProvider @ init", error);
      }
    }

    init();
  }, []);

  return (
    <GrowthBookProvider growthbook={featureFlagClient}>
      {props.children}
    </GrowthBookProvider>
  );
}
